import React from 'react';
import {observer} from 'mobx-react'
import Col from '../base-components/Col'
import { BaseUIComponentProps, replaceBillerInfo } from './BaseUIComponent';
import { IUIHtmlLinkDef } from '../../datatypes';

interface HtmlLinkProps extends BaseUIComponentProps {
    /** @override */
    metadata: IUIHtmlLinkDef;
}

class HtmlLink extends React.Component<HtmlLinkProps,{}> {
  render() {
    const {metadata} = this.props;
    const {
      properties,
      label,
      cssClasses,
      url,
      target      
    } = metadata;

    let {xs, sm, md, lg} = properties;
    let className = "html-link " + (cssClasses ? cssClasses : '');
    let billerUrl = replaceBillerInfo(url, this.props.formBean.Biller);

    return (
      <Col xs={xs} sm={sm} md={md} lg={lg}>
        <a className={className} href={billerUrl} target={target}> {label} </a>
      </Col>
    )
  }
}

export default observer(HtmlLink);